<template>
  <div class="plan-card-wrapper bloco-carteirinha" style="height: 90%;">
    <div v-if="selected.promotag" style="position: absolute;z-index: 999999;margin: 0;padding: 0;width: 100%;">
      <img :src="selected.promotag.url" style="width: 244px; position: absolute; top: -100px; left: 112px;" />
    </div>

    <div class="card mb-4 box-shadow plan-card" style="border-radius: 25px; height: 100%; margin: auto;">
      <div :style="headerStyle" class="card-header">
        <img :src="selected.img_frente" class="planos-carteirinha" style="translate: 0px -100px;" />
      </div>

      <h1 class="ps-5 pe-5 card-title plan-card-title" style="margin-top:10px; text-transform: uppercase">
        {{ name }}
      </h1>

      <div
        class="card-body plan-card-body d-flex flex-column ps-4 pe-4 pb-4 pt-1 justify-content-between align-item-start">
        <div style="height: 100%; display: flex; flex-direction: column; align-items: start">

          <div style="flex-grow:1;" class="plan-card-content text-start p-r2" v-html="description"></div>

          <div class="d-flex flex-column w-100 gap-3 mb-3">
            <div :class="{ 'group-item': true, active: selected.id === plan.id }" v-for="plan in plans" :key="plan.id"
              @click="selected = plan">
              <div class="d-flex p-3 mx-0">
                <div class="d-flex justify-content-center align-items-center me-3">
                  <div class="group-item-dot"></div>
                </div>
                <div class="text-start flex-grow-1 d-flex justify-content-between align-items-center">
                  <span style="font-size: 1.5em; text-transform: uppercase;">
                    {{ plan.nome_display || plan.nome }}
                  </span>
                </div>
                <div class="d-flex flex-column justify-content-end align-items-center" style="font-size: 1.2em;">
                  <strong>{{ currency(plan.valor) }}</strong>
                  <small>/ mensais</small>
                </div>
              </div>
            </div>
          </div>

          <div v-if="selected.congelado === 'N' && selected.link !== 'N'" style="width: 100%;">
            <a id="btn-quero-este" :href="redirect" style="border-radius: 8px;"
              class="btn btn-lg btn-block btn-primary fw-bold">
              QUERO ESTE
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { currency } from '../../filters/currency';
import Vue from 'vue';
import { truncate } from '../../filters/truncate';

export default Vue.extend({
  name: 'single-plan',

  props: {
    name: {
      type: String,
      required: false
    },
    plans: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selected: null
    };
  },

  created() {
    if (this.plans.length > 0) {
      this.selected = this.plans[0];
    }
  },

  computed: {
    headerStyle() {
      const baseStyle = 'height:100px; border-radius: 25px 25px 0px 0px;';

      if (this.selected.background_image) {
        return `${baseStyle} background-image: url('${this.selected.background_image.url}'); background-position: center center; background-size: cover;`;
      }

      return baseStyle;
    },

    description() {
      if (this.selected.showcase_thema) {
        return truncate(this.selected.showcase_thema, 500);
      }

      return truncate(this.selected.vantagens, 500);
    },

    redirect() {
      if (this.selected.redirect_url) {
        return this.selected.redirect_url;
      }

      return `/cadastro/dados-pessoais/${this.selected.id}`;
    }
  },

  methods: {
    currency(value) {
      return currency(value);
    },
  }
})
</script>


<style lang="scss">
.group-item {
  border: 1px solid var(--on-primary);
  border-radius: 8px;
  cursor: pointer;

  &.active {
    background-color: black;

    .group-item-dot {
      background-color: white;
    }
  }

  .group-item-dot {
    height: 12px;
    width: 12px;
    border-radius: 12px;
    border: 1px solid var(--on-primary);
  }
}
</style>